var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 180,
    viewBox: "0 0 167 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.041 68.1008L161.008 93.0513L160.252 97.8398C160.252 101.548 152.331 150.369 148.227 150.369L83.3484 105.545L11.3772 155.482C7.27278 155.482 2.95235 102.952 2.95235 99.2439L2.66432 93.0513L1.51221 68.1728L13.1054 58.1638L78.7399 1.45815C81.4402 -0.486049 85.2926 -0.486049 87.9929 1.45815L153.555 58.1638L165.041 68.1008Z",
    fill: "#062440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.898 67.9568V144.248H32.2954V45.9226H111.647L133.898 67.9568Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.898 67.9568V70.513H109.091V45.8146L111.648 45.9226L133.898 67.9568Z",
    fill: "#2C447D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.898 67.9568H111.647V45.9226L133.898 67.9568Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9326 120.09L122.124 82.1422C131.881 72.1692 145.851 66.4807 160.468 66.4807C163.889 66.4807 166.697 68.7489 166.697 71.5212V123.222V172.943C166.697 175.752 162.052 179.964 158.596 179.964H137.462L84.8966 126.355C83.1685 124.626 83.1685 121.89 84.9326 120.09Z",
    fill: "#09345D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7642 120.054L44.5725 82.1062C34.8155 72.1332 20.8821 66.4446 6.22862 66.4446C2.80828 66.4446 0 68.7129 0 71.4851V123.186V173.519C0 176.328 3.9964 180 7.41674 180L29.1989 179.928L81.7642 126.319C83.5284 124.554 83.5284 121.818 81.7642 120.054Z",
    fill: "#09345D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.697 152.205V174.095C166.697 177.372 163.384 180 159.28 180H7.41674C3.31233 180 0 177.336 0 174.095V152.205L78.7399 102.232C80.036 101.404 81.5482 100.972 83.0963 100.936C84.8245 100.9 86.5527 101.332 87.9928 102.232L166.697 152.205Z",
    fill: "#0B4275"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 143.096L68.5149 106.517L69.847 107.885L0 152.205V143.096Z",
    fill: "#062440"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.697 143.096L98.2177 106.517L96.8496 107.885L166.697 152.205V143.096Z",
    fill: "#062440"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0961 78.1818C75.1393 78.1818 68.6587 84.6625 68.6587 92.6193H97.5336C97.5336 84.6265 91.0529 78.1818 83.0961 78.1818Z",
    fill: "#C7DDF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0958 77.0657C87.2118 77.0657 90.5486 73.729 90.5486 69.613C90.5486 65.4969 87.2118 62.1602 83.0958 62.1602C78.9798 62.1602 75.6431 65.4969 75.6431 69.613C75.6431 73.729 78.9798 77.0657 83.0958 77.0657Z",
    fill: "#C7DDF3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.2cc588432e67a836368506447d0c6bb3.svg";
export { ForwardRef as ReactComponent };